export const config = {
  button: {
    size: {
      m: {
        customClasses: "hs-med-button hs-fs-16 px-3",
      },
      l: {
        customClasses: "hs-big-button hs-fs-16 px-3",
      },
      xs: {
        customClasses: "hs-xs-button",
      },
      s: {
        customClasses: "hs-s-button",
      },
      xsm: {
        customClasses: "hs-xsm-button",
      },
      xl: {
        customClasses: "hs-xl-button px-3",
      },
    },
    type: {
      link: {
        customClasses: "hs-button-link",
        textCustomClasses: "hs-text-primary hs-fs-14",
      },
      primary: {
        customClasses: "hs-button-primary",
        textCustomClasses: "hs-text-primary hs-fw-500 hs-fs-14",
      },
      outline: {
        customClasses: "hs-button-outline",
        textCustomClasses: "hs-text-outline",
      },
      outlinePrimary: {
        customClasses: "hs-button-outline-primary",
        textCustomClasses: "hs-button-text-primary",
      },
      secondary: {
        textCustomClasses: "hs-text-outline",
        customClasses: "",
      },
      danger: {
        customClasses: "hs-button-danger",
        textCustomClasses: "hs-color-white hs-fw-600",
      },
      text: {
        customClasses: "hs-button-text",
        textCustomClasses: "hs-text-primary hs-fw-600 hs-fs-14",
      },
      white: {
        customClasses: "hs-button-white",
        textCustomClasses: "hs-text-primary hs-fs-14",
      },
    },
    variant: {
      cancel: {
        customClasses: "hs-button-v-cancel",
      },
      danger: {
        customClasses: "hs-button-v-danger",
      },
      vanilla: {
        customClasses: "hs-button-vanilla",
      },
      grey: {
        customClasses: "hs-button-grey",
        textCustomClasses: "hs-text-grey hs-fw-600 hs-fs-14",
      },
    },
    customClasses: "d-flex align-items-center hs-border-6 hs-button ",
  },
  modal: {
    type: {
      success: {
        icon: {
          customClasses: "successInfoIcon",
        },
      },
    },
    header: {
      size: {
        s: {
          customClasses: "fs-6 fw-light",
        },
        m: {
          customClasses: "fs-4 fw-medium",
        },
      },
    },
  },
  input: {
    size: {
      xs: {
        customClasses: "hs-h-30-px",
      },
      s: {
        customClasses: "hs-h-34-px",
      },
      m: {
        customClasses: "hs-h-40-px",
      },
      l: {
        customClasses: "h-60",
      },
    },
    variant: {
      borderless: {
        customClasses: "hs-fs-14 hs-input-borderless",
      },
      underlined: {
        customClasses: "hs-fs-14 hs-input-underlined mt-1",
      },
      default: {
        customClasses: "hs-fs-14 hs-input-box hs-placeholder-text",
      },
      "line-input": {
        customClasses: "hs-fs-14 hs-input-box-line hs-placeholder-text",
      },
    },
  },
  text: {
    type: {
      secondary: {
        textCustomClasses: "hs-text-secondary",
      },
    },
    size: {
      s: {
        customClasses: "hs-fs-12 hs-fw-400",
      },
    },
    customClasses: "hs-text",
  },
};
